import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

export interface FileNameType {
  name: string;
  type: 'video' | 'image' | 'dicom' | 'text';
}

const timiming = '0.3s cubic-bezier(0.35, 0, 0.25, 1)';

@Component({
  selector: 'app-see-details',
  templateUrl: './see-details.component.html',
  styleUrls: ['./see-details.component.scss'],
  animations: [
    trigger('stretchDown', [
      state('close', style({
        opacity: 0,
        height: 0,
      })),
      state('open', style({
        opacity: 1,
        height: '100%'
      })),
      transition('open=>close', [
          animate(timiming)
        ]
      ),
      transition('close=>open', [
          animate(timiming)
        ]
      )
    ]),
    trigger('rotate', [
      state('normal', style({
        transform: 'rotate(0deg)'
      })),
      state('rotated', style({
        transform: 'rotate(180deg)'
      })),
      transition('normal=>rotated', [
          animate(timiming)
        ]
      ),
      transition('rotated=>normal', [
          animate(timiming)
        ]
      )
    ])
  ]
})
export class SeeDetailsComponent implements OnInit {

  @Input() recipients: string[];
  @Input() fileNames: FileNameType[];

  collapsed: boolean;

  constructor() {
    this.collapsed = false;
  }

  ngOnInit(): void {
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }

}
